export const preData = {
    my: {
        title: "မူကြိုတန်း",
        subtitle: "ပိဋကတ်အခြေခံပညာ မူကြိုသင်တန်း",
        examNote: "မူကြိုတန်း ၌ တစ်ဘာသာလျှင် ၆-ပုစ္ဆာ မေးရမည်။ အာဂုံအောင်မှတ် ၁၀-မှတ်နှင့်တကွ အောင်မှတ်မှာ ၂၄-မှတ် ဖြစ်သည်။ ၅၀-မှတ်သည် ဂုဏ်ထူးမှတ်၊ ၅၄-မှတ်သည် ဝိသိဋ္ဌဂုဏ်ထူးမှတ် ဖြစ်သည်။",
        introduction: "ဤအတန်း၌ - သဒ္ဓါဝဍ္ဎနဘာသာ၊ သဒ္ဒါဘာသာ၊ သင်္ဂဟဘာသာ၊ ပါဠိသိက္ခာဘာသာ ဟု ၄-ဘာသာ ပြဋ္ဌာန်းထား၏။",
        subjects: [
            {
                name: "သဒ္ဓါဝဍ္ဎနဘာသာ",
                description: "ရုပ်ပုံရှင်ကျင့်ဝတ်နှင့် ရတနာ့ဂုဏ်ရည်တို့ကို ပေါင်း၍ သဒ္ဓါဝဍ္ဎနဘာသာ ဟု ပြဋ္ဌာန်းထား၏။",
                subItems: ["ရုပ်ပုံရှင်ကျင့်ဝတ်", "ရတနာ့ဂုဏ်ရည်"]
            },
            {
                name: "သဒ္ဒါဘာသာ",
                description: "အခြေပြုသဒ္ဒါ (တွဲဖက်)နှင့် အခြေပြုသဒ္ဒါသုတ်နက်တို့ကို သင်ကြားပို့ချသည်။",
                subItems: [
                    "အခြေပြုသဒ္ဒါ (တွဲဖက်) - သန္ဓိ၊ နာမ်၊ အာချာတ်သုတ်စဉ်၊ နာမ်ဂိုဏ်းစဉ်",
                    "အခြေပြုသဒ္ဒါသုတ်နက် (သန္ဓိ၊ နာမ်)"
                ]
            },
            {
                name: "သင်္ဂဟဘာသာ",
                description: "စိတ်၊ စေတသိက်တို့ကို သင်ကြားပို့ချသည်။",
                subItems: ["အဘိဓမ္မတ္ထသင်္ဂဟပါဌ်", "အခြေပြုသင်္ဂြိုဟ်"]
            },
            {
                name: "ပါဠိသိက္ခာဘာသာ",
                description: "ပါဠိသိက္ခာနှင့် သဒ္ဒါအကျဉ်းစာအုပ်မှ ပါဠိသိက္ခာအကုန်နှင့် နာမ်ဂိုဏ်းအကျဉ်း၊ အာချာတ်ဂိုဏ်းအကျဉ်း၊ သန္ဓိအကျဉ်း",
                subItems: []
            }
        ],
        conclusion: "ဤမူကြိုတန်းကို တက်ရောက်ထားသူသည် ပါဠိစာပေသို့ စတင် ခြေလှမ်းနေပြီ ဟု ဆိုနိုင်၏၊ ပါဠိဝါကျ အတိုလေးများကို ရေးသားနိုင် ပြောနိုင်နေလေပြီ။"
    },
    en: {
        title: "Pre-Grade",
        subtitle: "Pitakat Basic Education Pre-Grade Course",
        examNote: "In Pre-Grade, each subject has 6 questions. With 10 marks for memorization, the passing mark is 24. 50 marks is distinction, and 54 marks is outstanding distinction.",
        introduction: "This grade consists of four subjects: Saddhāvaḍḍhana, Grammar, Saṅgaha, and Pāḷi Sikkhā.",
        subjects: [
            {
                name: "Saddhāvaḍḍhana Subject",
                description: "Combines Buddhist Ethics and Triple Gem qualities into the Saddhāvaḍḍhana subject.",
                subItems: ["Buddhist Ethics", "Triple Gem Qualities"]
            },
            {
                name: "Grammar Subject",
                description: "Teaches Basic Grammar (Combined) and Basic Grammar (Advanced Rules).",
                subItems: [
                    "Basic Grammar (Combined) - Sandhi, Noun, Verb sequences, Noun declensions",
                    "Basic Grammar Advanced (Sandhi, Noun)"
                ]
            },
            {
                name: "Saṅgaha Subject",
                description: "Covers consciousness and mental factors.",
                subItems: ["Abhidhammatthasaṅgaha Text", "Basic Saṅgaha"]
            },
            {
                name: "Pāḷi Sikkhā Subject",
                description: "Covers complete Pāḷi Sikkhā and concise grammar from the Pāḷi Sikkhā and Grammar Concise textbook.",
                subItems: []
            }
        ],
        conclusion: "Students who complete this Pre-Grade can be said to have taken their first steps into Pāḷi literature, now able to write and speak simple Pāḷi sentences."
    }
};